module.exports = __webpack_public_path__ + "c8fc792e1e9c0d2b2b1bc64e41e3e86a.png";